import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const activateDeactivateGatewayAction = getApiActionCreator(actionTypes.ACTIVATE_DEACTIVATE_GATEWAY_SETTINGS);
export const lastCommandStatusActivateRemoteConnectionAction = getApiActionCreator(actionTypes.LAST_COMMAND_ACTIVATE_ACTION_SETTINGS);

export const activateDeactivateGateway = (gatewayId, datacollectionUnitId, isActivate) => {
    return {
        type: actionTypes.ACTIVATE_DEACTIVATE_GATEWAY,
        gatewayId,
        datacollectionUnitId,
        isActivate
    };
};

export const lastCommandStatusActivateRemoteConnection = (gatewayId, requestType) => {
    return {
        type: actionTypes.LAST_COMMAND_ACTIVATE_ACTION,
        gatewayId,
        requestType
    };
};

export const clearStore = () => {
    return {
        type: actionTypes.CLEAR_STORE
    };
};
